import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { Amplify, Auth } from 'aws-amplify';
import awsconfig from '../../aws-exports'; // eslint-disable-line import/no-unresolved
import { HEADERS } from '../../common/enums/enums';

Amplify.configure(awsconfig);
export let baseUrl = '';

const baseQuery = fetchBaseQuery({
  baseUrl: 'https://',
  prepareHeaders: async headers => {
    const token = (await Auth.currentSession()).getIdToken().getJwtToken();
    headers.set(HEADERS.X_USER_POOL_ID, awsconfig.aws_user_pools_id);
    headers.set(
      HEADERS.X_APP_CLIENT_ID,
      awsconfig.aws_user_pools_web_client_id
    );
    headers.set(HEADERS.AUTHORIZATION, `Bearer ${token}`);
    return headers;
  },
  fetchFn: async (input, init) => {
    baseUrl ||= await Amplify.API.endpoint('clarityCore');
    const newUrl = input.url.replace('https://', `${baseUrl}/`);
    const body = await (input.headers.get('Content-Type')
      ? input.blob()
      : Promise.resolve());
    // input.duplex = 'half';
    const newRequest = new Request(newUrl, {
      method: input.method,
      headers: input.headers,
      body: body,
      referrer: input.referrer,
      referrerPolicy: input.referrerPolicy,
      mode: input.mode,
      credentials: input.credentials,
      cache: input.cache,
      redirect: input.redirect,
      integrity: input.integrity,
    });
    return fetch(newRequest, init);
  },
});

export const api = createApi({
  baseQuery,
  tagTypes: ['CurrentCompany'],
  endpoints: () => ({}),
  refetchOnFocus: true,
});
